// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_CHANGE_COMPANY,
} from './constants';

export function changeCompany(model) {
  return {
    type: USER_CHANGE_COMPANY,
    data:model
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_CHANGE_COMPANY:
      return {
        ...state,
        userCompany:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/changeCompany.js